import ApiJobTime from 'types/api/JobTime';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import JobTime from 'models/JobTime';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {}
export const list = async (params?: ListParams): Promise<ListCollection<JobTime>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobTimes, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.JobTimes];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiJobTime) => new JobTime(element)),
        meta: resource.meta,
    };
};

export interface SingleParams {
    slug: string;
}
export const single = async (params: SingleParams): Promise<JobTime> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicJobTime, params),
    });

    const data = response?.payload?.data;
    const resource: ApiJobTime = data && data[ApiResources.JobTime];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return new JobTime(resource);
};
